import "../../styles/ThirdParty/SideBar.scss";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Kyc from "./Kyc";
import Logo from "../../images/closecarbon_logo_1-removebg-preview 1.png";
import { useEffect, useState } from "react";

const SideBar = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.auth);


  const { pathname } = useLocation();

  const handleLogout = () => {
    dispatch({
      type: "LOGOUT_SUCCESS",
    });
    localStorage.removeItem("token");
    navigate("/third-party/login");
    window.scrollTo(0, 0);
  };

  const handeMobileMenuClose = () => {
    dispatch({
      type: "SET_MENU_VISIBLE",
      payload: false,
    });
  };

  useEffect(() => {
    handeMobileMenuClose();
  }, [pathname]);


  return (
    <div className="thirdparty_sidebar">
      <div className="logo_container">
        <div>
          <img src={Logo} alt="" className="logo pointer" onClick={() => navigate("/third-party/dashboard")} />
        </div>
      </div>

      <svg
        className="sidebar__ipad-pro"
        onClick={handeMobileMenuClose}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M12.8999 1.50004C15.2999 1.65004 17.5499 2.85004 19.1999 4.50004C21.1499 6.60004 22.1999 9.15004 22.1999 12.15C22.1999 14.55 21.2999 16.8 19.7999 18.75C18.2999 20.55 16.1999 21.9 13.7999 22.35C11.3999 22.8 8.99994 22.5 6.89994 21.3C4.79994 20.1 3.14994 18.3 2.24994 16.05C1.34994 13.8 1.19994 11.25 1.94994 9.00004C2.69994 6.60004 4.04994 4.65004 6.14994 3.30004C8.09994 1.95004 10.4999 1.35004 12.8999 1.50004ZM13.6499 20.85C15.5999 20.4 17.3999 19.35 18.7499 17.7C19.9499 16.05 20.6999 14.1 20.5499 12C20.5499 9.60004 19.6499 7.20004 17.9999 5.55004C16.4999 4.05004 14.6999 3.15004 12.5999 3.00004C10.6499 2.85004 8.54994 3.30004 6.89994 4.50004C5.24994 5.70004 4.04994 7.35004 3.44994 9.45004C2.84994 11.4 2.84994 13.5 3.74994 15.45C4.64994 17.4 5.99994 18.9 7.79994 19.95C9.59994 21 11.6999 21.3 13.6499 20.85ZM11.8499 11.25L15.4499 7.50004L16.4999 8.55004L12.8999 12.3L16.4999 16.05L15.4499 17.1L11.8499 13.35L8.24994 17.1L7.19994 16.05L10.7999 12.3L7.19994 8.55004L8.24994 7.50004L11.8499 11.25Z"
          fill="#667185"
        />
      </svg>
      <div className="menu">
        {/* <div
          className={
            pathname.includes("dashboard")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() =>{ navigate("/third-party/dashboard")
          window.scrollTo(0, 0);
        }}
        >
          <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M21 12.5V17H3V5H8.25V3.5H3C2.60218 3.5 2.22064 3.65804 1.93934 3.93934C1.65804 4.22064 1.5 4.60218 1.5 5V17C1.5 17.3978 1.65804 17.7794 1.93934 18.0607C2.22064 18.342 2.60218 18.5 3 18.5H9V21.5H6V23H18V21.5H15V18.5H21C21.3978 18.5 21.7794 18.342 22.0607 18.0607C22.342 17.7794 22.5 17.3978 22.5 17V12.5H21ZM13.5 21.5H10.5V18.5H13.5V21.5Z"
              fill="#667185"
            />
            <path
              d="M13.5 14.0001H13.4925C13.3309 13.9984 13.1742 13.9445 13.0456 13.8466C12.9171 13.7486 12.8237 13.6117 12.7792 13.4563L11.4345 8.75008H8.25V7.25008H12C12.163 7.24999 12.3216 7.30302 12.4518 7.40113C12.582 7.49924 12.6767 7.6371 12.7215 7.79383L13.527 10.6138L15.7838 3.27883C15.8324 3.12662 15.9278 2.99361 16.0564 2.8987C16.185 2.80378 16.3402 2.75178 16.5 2.75008C16.658 2.74771 16.8126 2.79633 16.9408 2.88874C17.069 2.98115 17.164 3.11242 17.2118 3.26308L18.54 7.25008H22.5V8.75008H18C17.8425 8.75012 17.689 8.70059 17.5613 8.60851C17.4335 8.51644 17.338 8.38649 17.2882 8.23708L16.5285 5.95708L14.217 13.4706C14.1698 13.6239 14.0747 13.7581 13.9457 13.8534C13.8166 13.9487 13.6604 14.0001 13.5 14.0001Z"
              fill="#667185"
            />
          </svg>

          <div>Monitoring</div>
        </div> */}
        {/* {auth?.userInfo?.role === "thirdParty" && <div
          className={
            pathname.includes("validation")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() =>{ navigate("/third-party/validation")
          window.scrollTo(0, 0);
        }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M10.125 23.1113C9.9954 23.1112 9.86802 23.0777 9.75525 23.0138L3.38025 19.4025C3.26482 19.3371 3.16881 19.2423 3.102 19.1276C3.0352 19.013 3 18.8827 3 18.75V11.25C3 11.1174 3.0352 10.9871 3.102 10.8724C3.16881 10.7578 3.26482 10.6629 3.38025 10.5975L9.75525 6.98628C9.86803 6.92246 9.99541 6.88892 10.125 6.88892C10.2546 6.88892 10.382 6.92246 10.4948 6.98628L16.8698 10.5975C16.9852 10.6629 17.0812 10.7578 17.148 10.8724C17.2148 10.9871 17.25 11.1174 17.25 11.25V18.75C17.25 18.8827 17.2148 19.013 17.148 19.1276C17.0812 19.2423 16.9852 19.3371 16.8698 19.4025L10.4948 23.0138C10.382 23.0777 10.2546 23.1112 10.125 23.1113ZM4.5 18.3128L10.125 21.4988L15.75 18.3128V11.6873L10.125 8.50128L4.5 11.6865V18.3128Z"
              fill="#667185"
            />
            <path
              d="M21.0001 12.75H19.5001V5.68728L13.8751 2.50128L7.86987 5.90253L7.13037 4.59753L13.5054 0.986282C13.6182 0.922459 13.7455 0.888916 13.8751 0.888916C14.0047 0.888916 14.1321 0.922459 14.2449 0.986282L20.6199 4.59753C20.7353 4.66294 20.8313 4.7578 20.8981 4.87243C20.9649 4.98706 21.0001 5.11736 21.0001 5.25003V12.75Z"
              fill="#667185"
            />
          </svg>

          <div>Validation</div>
        </div>} */}
        <div
          className={
            pathname.includes("verification")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() => {
            navigate("/third-party/verification")
            window.scrollTo(0, 0);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M18 21H22.5V22.5H18V21Z" fill="#667185" />
            <path
              d="M15.75 22.5C16.1642 22.5 16.5 22.1642 16.5 21.75C16.5 21.3358 16.1642 21 15.75 21C15.3358 21 15 21.3358 15 21.75C15 22.1642 15.3358 22.5 15.75 22.5Z"
              fill="#667185"
            />
            <path
              d="M21.75 19.5C22.1642 19.5 22.5 19.1642 22.5 18.75C22.5 18.3358 22.1642 18 21.75 18C21.3358 18 21 18.3358 21 18.75C21 19.1642 21.3358 19.5 21.75 19.5Z"
              fill="#667185"
            />
            <path
              d="M19.5 19.5H15V18H19.5V19.5ZM18 15H22.5V16.5H18V15Z"
              fill="#667185"
            />
            <path
              d="M15.75 16.5C16.1642 16.5 16.5 16.1642 16.5 15.75C16.5 15.3358 16.1642 15 15.75 15C15.3358 15 15 15.3358 15 15.75C15 16.1642 15.3358 16.5 15.75 16.5Z"
              fill="#667185"
            />
            <path
              d="M16.1198 10.5974L9.74475 6.98615C9.63199 6.92226 9.5046 6.88867 9.375 6.88867C9.2454 6.88867 9.11801 6.92226 9.00525 6.98615L2.63025 10.5974C2.51482 10.6628 2.41881 10.7577 2.352 10.8723C2.2852 10.9869 2.25 11.1172 2.25 11.2499V18.7499C2.25 18.8826 2.2852 19.0129 2.352 19.1275C2.41881 19.2421 2.51482 19.337 2.63025 19.4024L9.00525 23.0136L9.74475 21.7087L3.75 18.3126V11.6872L9.375 8.50115L15 11.6872V13.4999H16.5V11.2499C16.5 11.1172 16.4648 10.9869 16.398 10.8723C16.3312 10.7577 16.2352 10.6628 16.1198 10.5974Z"
              fill="#667185"
            />
            <path
              d="M18.7501 11.2499H20.2501V5.2499C20.2501 5.11723 20.2149 4.98693 20.1481 4.8723C20.0813 4.75767 19.9853 4.66281 19.8699 4.5974L13.4949 0.98615C13.3821 0.922256 13.2547 0.888672 13.1251 0.888672C12.9955 0.888672 12.8681 0.922256 12.7554 0.98615L6.38037 4.5974L7.11987 5.9024L13.1251 2.5004L18.7501 5.68715V11.2499Z"
              fill="#667185"
            />
          </svg>

          <div>Verification</div>
        </div>
        {/* <div
          className={
            pathname.includes("carbon-credit-issuance")
              ? "menu_item menu_active"
              : "menu_item"
          }
          onClick={() =>{
            navigate("/third-party/carbon-credit-issuance")
            window.scrollTo(0, 0);
            }
          }
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M22.1318 13.2668L17.6318 10.6043C17.5162 10.5358 17.3843 10.4997 17.2499 10.4999C17.1155 10.5 16.9837 10.5363 16.8682 10.605L12.3682 13.2675C12.2561 13.3337 12.1631 13.428 12.0985 13.5411C12.0339 13.6543 12 13.7823 12 13.9125V19.0875C12 19.353 12.1402 19.5983 12.3682 19.7325L16.8682 22.395C16.9836 22.4643 17.1155 22.5008 17.25 22.5008C17.3845 22.5008 17.5164 22.4643 17.6318 22.395L22.1318 19.7325C22.2439 19.6664 22.3369 19.5721 22.4015 19.4589C22.4661 19.3458 22.5 19.2178 22.5 19.0875V13.9125C22.5 13.7822 22.4661 13.6541 22.4015 13.5408C22.3369 13.4276 22.244 13.3331 22.1318 13.2668ZM21 18.66L17.25 20.8785L13.5 18.66V14.34L17.25 12.1215L21 14.34V18.66Z"
              fill="#667185"
            />
            <path
              d="M4.5 5.25C4.91421 5.25 5.25 4.91421 5.25 4.5C5.25 4.08579 4.91421 3.75 4.5 3.75C4.08579 3.75 3.75 4.08579 3.75 4.5C3.75 4.91421 4.08579 5.25 4.5 5.25Z"
              fill="#667185"
            />
            <path
              d="M6.75 5.25C7.16421 5.25 7.5 4.91421 7.5 4.5C7.5 4.08579 7.16421 3.75 6.75 3.75C6.33579 3.75 6 4.08579 6 4.5C6 4.91421 6.33579 5.25 6.75 5.25Z"
              fill="#667185"
            />
            <path
              d="M21 1.5H3C2.17275 1.5 1.5 2.17275 1.5 3V18C1.5 18.8272 2.17275 19.5 3 19.5H9.75V18H3V7.5H21V10.5H22.5V3C22.5 2.17275 21.8272 1.5 21 1.5ZM3 6V3H21V6H3Z"
              fill="#667185"
            />
          </svg>

          <div>CCRT</div>
        </div> */}

        {/* <div
          className={
            pathname.includes("iot") ? "menu_item active_iot" : "menu_item"
          }
          onClick={() => {
            navigate("/third-party/iot")
            window.scrollTo(0, 0);
          }}
        >
          <svg
            className="stroke"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14 1H15C15.5304 1 16.0391 1.21071 16.4142 1.58579C16.7893 1.96086 17 2.46957 17 3V4M17 14V15C17 15.5304 16.7893 16.0391 16.4142 16.4142C16.0391 16.7893 15.5304 17 15 17H14M4 17H3C2.46957 17 1.96086 16.7893 1.58579 16.4142C1.21071 16.0391 1 15.5304 1 15V14M1 4V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H4M9 15V17M1 9H3M9 1V3M17 9H15M6 9C6 9.79565 6.31607 10.5587 6.87868 11.1213C7.44129 11.6839 8.20435 12 9 12C9.79565 12 10.5587 11.6839 11.1213 11.1213C11.6839 10.5587 12 9.79565 12 9C12 8.20435 11.6839 7.44129 11.1213 6.87868C10.5587 6.31607 9.79565 6 9 6C8.20435 6 7.44129 6.31607 6.87868 6.87868C6.31607 7.44129 6 8.20435 6 9Z"
              stroke="#667185"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div>IoT Devicess</div>
//         </div> */}
{/* 
//         <div
//           className={
//             pathname.includes("history") ? "menu_item active_iot" : "menu_item"
//           }
//           onClick={() =>{ navigate("/third-party/history")
//           window.scrollTo(0, 0);
//         }}
//         >
//           <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
//   <path d="M3 17.6242V7.37422L12 2.19922L21 7.37422V12.7742C20.7 12.5576 20.3833 12.3702 20.05 12.2122C19.7167 12.0542 19.3667 11.9166 19 11.7992V9.59922L15.4 11.6742C14.4667 11.9076 13.6207 12.3036 12.862 12.8622C12.1033 13.4209 11.4827 14.0999 11 14.8992V13.0742L5 9.59922V16.4492L10.05 19.3742C10.1167 19.9076 10.2417 20.4202 10.425 20.9122C10.6083 21.4042 10.8417 21.8666 11.125 22.2992C11.0917 22.2826 11.0707 22.2699 11.062 22.2612C11.0533 22.2526 11.0327 22.2406 11 22.2252L3 17.6242ZM12 4.49922L6.075 7.92422L12 11.3492L17.925 7.92422L12 4.49922ZM17 23.4992C15.6167 23.4992 14.4373 23.0116 13.462 22.0362C12.4867 21.0609 11.9993 19.8819 12 18.4992C12 17.1159 12.4877 15.9366 13.463 14.9612C14.4383 13.9859 15.6173 13.4986 17 13.4992C18.3833 13.4992 19.5627 13.9869 20.538 14.9622C21.5133 15.9376 22.0007 17.1166 22 18.4992C22 19.8826 21.5123 21.0619 20.537 22.0372C19.5617 23.0126 18.3827 23.4999 17 23.4992ZM17.5 18.2992V15.4992H16.5V18.6992L18.65 20.8492L19.35 20.1492L17.5 18.2992Z" fill="#667185"/>
// </svg>

//           <div>History</div>
//         </div> */}

        <div
          className={
            pathname.includes("profile") ? "menu_item active_iot" : "menu_item"
          }
          onClick={() => {
            navigate("/third-party/profile");
            window.scrollTo(0, 0);
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12.2948 9.01453C11.6793 8.95374 11.06 9.08469 10.5218 9.38945C9.98353 9.69421 9.55266 10.1579 9.28813 10.717C9.02361 11.2761 8.93836 11.9033 9.04406 12.5127C9.14976 13.1221 9.44125 13.684 9.87861 14.1213C10.316 14.5587 10.8778 14.8502 11.4872 14.9559C12.0967 15.0616 12.7239 14.9763 13.283 14.7118C13.8421 14.4473 14.3057 14.0164 14.6105 13.4782C14.9152 12.94 15.0462 12.3207 14.9854 11.7052C14.9161 11.0151 14.6104 10.3703 14.12 9.87995C13.6296 9.38958 12.9848 9.08384 12.2948 9.01453ZM19.5182 12C19.5163 12.3261 19.4923 12.6517 19.4465 12.9745L21.5657 14.6367C21.658 14.7132 21.7202 14.8199 21.7412 14.9379C21.7622 15.056 21.7407 15.1776 21.6806 15.2812L19.6757 18.75C19.6148 18.8527 19.5197 18.9305 19.407 18.9699C19.2943 19.0093 19.1713 19.0076 19.0598 18.9652L16.9551 18.1177C16.839 18.0714 16.7133 18.0547 16.5892 18.0691C16.4651 18.0834 16.3465 18.1283 16.244 18.1997C15.9228 18.4209 15.5853 18.6174 15.2343 18.7875C15.124 18.8411 15.0285 18.9211 14.9564 19.0203C14.8843 19.1196 14.8378 19.2351 14.8209 19.3566L14.5054 21.6014C14.4847 21.72 14.4234 21.8276 14.3321 21.906C14.2408 21.9844 14.1251 22.0287 14.0048 22.0312H9.99509C9.87675 22.0292 9.76264 21.9869 9.67155 21.9113C9.58047 21.8357 9.51784 21.7314 9.494 21.6155L9.179 19.3739C9.16131 19.2511 9.11354 19.1345 9.03994 19.0346C8.96634 18.9346 8.86919 18.8544 8.75712 18.8011C8.4066 18.6319 8.07021 18.4349 7.75118 18.2119C7.64904 18.1408 7.53082 18.0963 7.40717 18.0823C7.28353 18.0683 7.15835 18.0853 7.0429 18.1317L4.93868 18.9788C4.82717 19.0212 4.70425 19.023 4.59158 18.9837C4.4789 18.9444 4.3837 18.8666 4.32275 18.7641L2.3179 15.2953C2.25763 15.1917 2.23609 15.07 2.25712 14.952C2.27815 14.834 2.34039 14.7272 2.43275 14.6508L4.22384 13.2445C4.32197 13.1666 4.39909 13.0655 4.4482 12.9502C4.49732 12.835 4.51687 12.7093 4.50509 12.5845C4.48822 12.3891 4.4779 12.1941 4.4779 11.9986C4.4779 11.8031 4.48775 11.6109 4.50509 11.4197C4.51558 11.2957 4.49507 11.1711 4.4454 11.057C4.39573 10.9429 4.31846 10.843 4.22056 10.7662L2.4304 9.36C2.33954 9.28317 2.27862 9.17681 2.2583 9.05957C2.23799 8.94232 2.25959 8.82167 2.31931 8.71875L4.32415 5.25C4.38504 5.14734 4.48021 5.06946 4.59289 5.0301C4.70557 4.99074 4.82853 4.99242 4.94009 5.03484L7.04478 5.88234C7.16084 5.92856 7.28656 5.94525 7.41066 5.93094C7.53476 5.91662 7.65338 5.87174 7.75587 5.80031C8.07708 5.57912 8.41461 5.38262 8.76556 5.2125C8.87589 5.15887 8.97132 5.07891 9.04343 4.97966C9.11553 4.88042 9.16209 4.76494 9.179 4.64344L9.49447 2.39859C9.51519 2.28004 9.57644 2.17236 9.66775 2.09396C9.75906 2.01555 9.87476 1.9713 9.99509 1.96875H14.0048C14.1231 1.9708 14.2372 2.01309 14.3283 2.08867C14.4194 2.16425 14.482 2.2686 14.5059 2.38453L14.8209 4.62609C14.8386 4.74894 14.8863 4.86551 14.9599 4.96544C15.0335 5.06537 15.1307 5.14557 15.2427 5.19891C15.5933 5.3681 15.9297 5.56514 16.2487 5.78813C16.3508 5.85919 16.469 5.90373 16.5927 5.91772C16.7163 5.93172 16.8415 5.91473 16.957 5.86828L19.0612 5.02125C19.1727 4.97879 19.2956 4.97704 19.4083 5.01631C19.521 5.05558 19.6162 5.13336 19.6771 5.23594L21.682 8.70469C21.7422 8.80832 21.7638 8.92999 21.7428 9.04802C21.7217 9.16604 21.6595 9.27278 21.5671 9.34922L19.776 10.7555C19.6775 10.8331 19.5999 10.9342 19.5504 11.0494C19.5008 11.1647 19.4809 11.2905 19.4924 11.4155C19.5079 11.6095 19.5182 11.8045 19.5182 12Z"
              stroke="#667185"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>

          <div>Settings</div>
        </div>
      </div>

      <div className="logout pointer" onClick={handleLogout}>
        <svg
          width="20"
          height="18"
          viewBox="0 0 20 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M15 4L13.59 5.41L16.17 8H6V10H16.17L13.59 12.58L15 14L20 9L15 4ZM2 2H10V0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H10V16H2V2Z"
            fill="#667185"
          />
        </svg>

        <div>Log out</div>
      </div>

      <Kyc />
    </div>
  );
};

export default SideBar;
